import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";
import { IStatements } from "./assessment";

export const useGetStatements = (questionId: string) => {
    const { user, siteId } = useAuth();
    const [getRecords] = useLazyReadMultipleQuery();
    const [statements, setStatements] = useState<IStatements[]>([]);

    useEffect(() => {
        if (questionId) {
            getStatements();
        }
        // eslint-disable-next-line
    }, [questionId]);

    const getStatements = (): Promise<void> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.');
        }

        return getRecords({
            userId: user?.contactId || '',
            portalId: siteId || '',
            tableId: "edtec365_statement",
            fieldList: ["edtec365_name", "edtec365_statementid"],
            filters: [{
                group: 0, filters: [
                    { field: "edtec365_question", type: FieldFilterType.Const, value: questionId }
                ]
            }]
        }).unwrap().then((data) => {

            const questionsRecords = data.records.map(record => ({
                statementid: record["edtec365_statementid"] as string,
                name: record["edtec365_name"] as string,
            }));

            setStatements(questionsRecords);
        }).catch(error => {
            console.error('Error fetching questions:', error);
        });
    };
    return { statements };
};
